import { faSortAmountDownAlt } from '@fortawesome/pro-regular-svg-icons';
import { faArrowLeft, faCheck, faTh } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    BACK_TO_LIST_OF_GROUPS,
    GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS_AND_FORUMS,
    GROUP_LIST,
    RECENT_COMMENTS,
    RECENT_POSTS,
    YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR,
} from 'mk/autogenerated/translations/GroupSubscribedFeed.35648366945f435db6f25520d940e7fd'
import GroupFeedPosts from 'mk2/apps/groups/components/GroupFeedPosts';
import { OrderBy } from 'mk2/apps/groups/containers/GroupFeed/GroupFeedPage';
import { groupsListUrl, groupsSubscribedFeedUrl } from 'mk2/apps/groups/urls';
import { Failure } from 'mk2/components/errors/Failure';
import { MenuItem } from 'mk2/components/menu/MenuItem';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { ListItem } from 'mk2/components/ListItem';
import { NoResults } from 'mk2/components/NoResults';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { Menu } from 'mk2/containers/Menu/Menu';
import { isLoading, isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { parse, stringify } from 'query-string';
import React from 'react';
import { GROUP_SUBSCRIBED_FEED_MENU_ORDERBY } from './GroupSubscribedFeed.constants';
import styles from './GroupSubscribedFeed.mscss';
import { Props, ScrollToPosition } from './GroupSubscribedFeedPage';

class GroupSubscribedFeed extends React.PureComponent<Props> {

    public componentDidMount() {
        const { loadingState, onScrollTo } = this.props;

        if (loadingState === LoadingState.SUCCESS_ON_SERVER) {
            const qs = parse(this.props.location.search);
            if (qs.scrollto) {
                onScrollTo(qs.scrollto as ScrollToPosition);
            }
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const p = this.props;

        if (// zmenil sa feed (url) alebo page z feedu
            (p.location.pathname !== prevProps.location.pathname || p.pageRef !== prevProps.pageRef) &&
            // nevraciame sa cez 'Back'
            p.history.action !== 'POP' &&
            // a nacitali sme z cache (LoadingSwitch nespustil groupSubscribedFeedFetchTrigger)
            isSuccess(p.loadingState)
        ) {
            // defaultne sa scrollne na konci fetchGroupSubscribedFeed sagy, ale ta sa nespusti
            // tak vykonaj scroll side-effect
            const qs = parse(p.location.search);
            if (qs.scrollto) {
                p.onScrollTo(qs.scrollto as ScrollToPosition);
            }
        }
    }

    public render() {
        const { loadingState, posts } = this.props;

        return (
            <div className={styles.GroupSubscribedFeed}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInitOrSuccess}
                    onRenderSuccess={this.renderInitOrSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={posts && posts.length > 0}
                />
            </div>
        );
    }

    private renderInitOrSuccess = () => {
        const {
            commentsCounts, complaintsCounts, complaintsOpened, errorMessage, loadingState, location,
            isMobile, moderatorUsersByGroupId, numberOfPages, onChangeSticky, onDelete, onGroupFeedMenuOrderBy,
            onPostToggleMenuMore, onReport, orderBy, pageRef, permissions, posts, feedLoaded, requestUser,
            staticContext, userAgent, groupsCount, isAdmin,
        } = this.props;

        return (
            <React.Fragment>
                <ListItem
                    isLast
                    className={styles.GroupSubscribedFeed__list}
                    to={groupsListUrl}
                    icon={<span className={styles.GroupSubscribedFeed__list__icon}><FontAwesomeIcon icon={faTh} /></span>}
                    count={groupsCount}
                >
                    {GROUP_LIST}
                </ListItem>

                {isLoading(loadingState) || posts.length > 0 ? (
                    <div className={styles.GroupSubscribedFeed__orderBy}>
                        <Menu
                            menuId={GROUP_SUBSCRIBED_FEED_MENU_ORDERBY}
                            trigger={(
                                <Btn
                                    className={styles.GroupSubscribedFeed__orderBy__trigger}
                                    type={BtnType.BlackText}
                                    icon={faSortAmountDownAlt}
                                    onClick={onGroupFeedMenuOrderBy}
                                />
                            )}
                            triggerShadow={false}
                        >
                            <MenuItem
                                label={<span className={cx(styles.GroupSubscribedFeed__orderBy__item, orderBy === 'posts' && styles['GroupSubscribedFeed__orderBy__item--active'])}><FontAwesomeIcon className={cx(styles.GroupSubscribedFeed__orderBy__item__icon, orderBy !== 'posts' && styles['GroupSubscribedFeed__orderBy__item__icon--notActive'])} icon={faCheck} /> {RECENT_POSTS}</span>}
                                onClick={this.handleOrderByPosts}
                            />
                            <MenuItem
                                label={<span className={cx(styles.GroupSubscribedFeed__orderBy__item, orderBy === 'comments' && styles['GroupSubscribedFeed__orderBy__item--active'])}><FontAwesomeIcon className={cx(styles.GroupSubscribedFeed__orderBy__item__icon, orderBy !== 'comments' && styles['GroupSubscribedFeed__orderBy__item__icon--notActive'])} icon={faCheck} /> {RECENT_COMMENTS}</span>}
                                onClick={this.handleOrderByComments}
                            />
                        </Menu>
                    </div>
                ) : null}

                {isSuccess(loadingState) && posts.length === 0 && (
                    <NoResults
                        message={YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR}
                        detailMessage={<Interpolate i18nKey={GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS_AND_FORUMS} components={[<Link to={groupsListUrl} key={0} />]} />}
                        noIcon
                    />
                )}

                <div id="scrolltoFirstHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}

                <GroupFeedPosts
                    commentsCounts={commentsCounts}
                    complaintsCounts={complaintsCounts}
                    complaintsOpened={complaintsOpened}
                    errorMessage={errorMessage}
                    history={this.props.history}
                    loadingState={loadingState}
                    location={location}
                    isMobile={isMobile}
                    moderatorUsersByGroupId={moderatorUsersByGroupId}
                    numberOfPages={numberOfPages}
                    onChangeSticky={onChangeSticky}
                    onDelete={onDelete}
                    onGroupLeave={this.handleGroupLeave}
                    onHideGroupInFeed={this.handleHideGroupInFeed}
                    onPostToggleMenuMore={onPostToggleMenuMore}
                    onReport={onReport}
                    pageRef={pageRef}
                    permissions={permissions}
                    posts={posts}
                    feedLoaded={feedLoaded}
                    requestUser={requestUser}
                    showGroup
                    showHashtagsBox={false}
                    showStrips
                    staticContext={staticContext}
                    userAgent={userAgent}
                    isAdmin={isAdmin}
                />

                <div id="scrolltoLastHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
            </React.Fragment>
        );
    };

    private renderFailure = () => {
        const { errorMessage, staticContext } = this.props;

        return (
            <Failure
                staticContext={staticContext}
                errorMessage={errorMessage}
                onRetry={this.load}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_LIST_OF_GROUPS}
                        icon={faArrowLeft}
                        link={groupsListUrl}
                    />
                }
            />
        );
    };

    private load = () => {
        const { location, onLoad, orderBy, pageRef, posts } = this.props;
        const numPostsBeforeLoad = posts.length;
        onLoad(orderBy, pageRef, location, numPostsBeforeLoad);
    };

    private handleOrderByPosts = () => {
        this.handleOrderBy('posts');
    };

    private handleOrderByComments = () => {
        this.handleOrderBy('comments');
    };

    private handleOrderBy = (orderBy: OrderBy) => {
        if (this.props.orderBy === orderBy) {
            return;
        }

        const search = {
            ...((orderBy !== 'posts') ? { orderby: orderBy } : {}),
        };

        this.props.history.replace({
            pathname: groupsSubscribedFeedUrl,
            search: search ? stringify(search) : undefined,
        });
    };

    private handleGroupLeave = (groupId: number) => {
        const { onGroupLeave } = this.props;
        onGroupLeave(groupId, this.load);
    };

    private handleHideGroupInFeed = (groupId: number) => {
        const { onHideGroupInFeed } = this.props;
        onHideGroupInFeed(groupId, this.load);
    };
}

export default GroupSubscribedFeed;
